import axiosClient from "./axiosClient";
import { CheckNullParams } from "../utils/CheckNullParams";
const menuApi = {
  getMenus: (params) => {
    const url = "menu";
    const payload = CheckNullParams(params);
    return axiosClient.get(url, {
      params: payload,
    });
  },

  getMenu: (id) => {
    const url = "menu";
    return axiosClient.get(url + "/" + id);
  },

  createMenu: (params) => {
    const url = "menu";
    const payload = CheckNullParams(params);
    return axiosClient.post(url, payload);
  },
  updateMenu: (id, payload) => {
    const url = "menu/";
    return axiosClient.patch(url + id, payload);
  },
  deleteMenu: (params) => {
    const url = "menu";
    console.log("params", params);
    return axiosClient.delete(url, { params });
  },
};

export default menuApi;
